import { NextResponse } from 'next/server'
import { query, queryOne, uuid } from '@/lib/db'

export async function GET(req: Request) {
  const { searchParams } = new URL(req.url)
  const shopId = searchParams.get('shop_id')
  const inStock = searchParams.get('in_stock')
  const search = searchParams.get('search')

  let sql = `
    SELECT a.*, c.name as category_name, c.color as category_color
    FROM articles a
    LEFT JOIN categories c ON a.category_id = c.id
    WHERE a.shop_id = ?
  `
  const params: any[] = [shopId]

  if (inStock === '1') { sql += ' AND a.stock > 0' }
  if (search) { sql += ' AND (a.name LIKE ? OR a.barcode LIKE ?)'; params.push(`%${search}%`, `%${search}%`) }

  sql += ' ORDER BY a.name'

  const rows = await query(sql, params)
  const articles = rows.map(r => ({
    ...r,
    category: r.category_name ? { id: r.category_id, name: r.category_name, color: r.category_color } : null,
  }))
  return NextResponse.json(articles)
}

export async function POST(req: Request) {
  const body = await req.json()

  // Bulk import
  if (Array.isArray(body)) {
    const BATCH = 50
    for (let i = 0; i < body.length; i += BATCH) {
      const batch = body.slice(i, i + BATCH)
      for (const item of batch) {
        await query(
          'INSERT INTO articles (id, shop_id, name, barcode, ras_mel, prix_vente, prix_min, stock, stock_alert, unit) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)',
          [uuid(), item.shop_id, item.name, item.barcode || null, item.ras_mel, item.prix_vente, item.prix_min, item.stock, item.stock_alert || 5, item.unit || 'pièce']
        )
      }
    }
    return NextResponse.json({ ok: true, count: body.length })
  }

  const id = uuid()
  await query(
    'INSERT INTO articles (id, shop_id, category_id, name, barcode, ras_mel, prix_vente, prix_min, stock, stock_alert, unit) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)',
    [id, body.shop_id, body.category_id || null, body.name, body.barcode || null, body.ras_mel, body.prix_vente, body.prix_min, body.stock, body.stock_alert || 5, body.unit || 'pièce']
  )
  const article = await queryOne('SELECT * FROM articles WHERE id = ?', [id])
  return NextResponse.json(article)
}
